import React from 'react';
import Input, { Props as InputProps } from './Input';
import { Controller, RegisterOptions, UseFormMethods } from 'react-hook-form';

type Props = {
    form: UseFormMethods<any>;
    name: string;
    rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & InputProps;

const InputController = ({ form, name, rules, ...props }: Props) => {

    return (
        <Controller
            render={({ ref, onChange, value }) => {
                return (
                    <Input
                        {...props}
                        ref={ref}
                        form={undefined}
                        onChange={onChange} 
                        value={value}
                        placeholder={props.placeholder}
                    />
                );
            }}
            control={form.control}
            name={name}
            defaultValue={form.getValues(name) || ''}
            rules={rules}
        />
    );
};

export default InputController;
